import { createSlice } from '@reduxjs/toolkit';
import { GENERIC_PAYMENT_SCHEMA, PAYMENT_DEBT_SCHEMA, SIGNATURE_SCHEMA } from '../../utilities/objectSchemas';

const initialState = {
    id: 0,
    agreementCode: "",
    agreementFile: "",
    quotation: {
        pricing: {
            taxes: {
                amount: 0,
                breakdown: {}
            },
            extras: {
                amount: 0,
                breakdown: {}
            },
            rate: {
                amount: 0,
                breakdown: {}
            }
        },
        total: 0,
    },
    classes: {
        classCode: "",
        classDesc: "",
        passengers: 0,
        luggage: 0,
        smallImage: ""
    },
    signature: SIGNATURE_SCHEMA,
    checkIn: GENERIC_PAYMENT_SCHEMA,
    payment: GENERIC_PAYMENT_SCHEMA,
    debtInfo: PAYMENT_DEBT_SCHEMA
};

export const agreementSlice = createSlice({
    name: 'agreement',
    initialState,
    reducers: {
        resetAgreement: () => initialState,
        setAgreement: (state, { payload } ) => {
            state.id = payload.id;
            state.agreementCode = payload.agreementCode;
            state.quotation = payload.quotation;
            state.classes = payload.classes;
            state.debtInfo.totalDebt = payload.quotation.total;
            state.debtInfo.subtotal = payload.quotation.taxes.amount;
        },
        setInitializeDebt: (state, { payload } ) => {
            state.debtInfo.totalDebt = payload.totalDebt;
            state.debtInfo.subtotal = payload.subtotal;
            state.debtInfo.currency = payload.currency;
            state.debtInfo.reservationCode = payload.reservationCode;
        },
        setDebtInfo: (state, { payload } ) => {
            state.debtInfo = payload;
        },
        setSignature: (state, { payload } ) => {
            if(!!state.signature.answers.answer1){
                payload.answers = {
                    ...state.signature.answers
                }
            }
            state.signature = payload;
        },
        setAgreementFile: (state, { payload }) => {
            state.agreementFile = payload;
        },
        setPaymentInfo: (state, { payload }) => {
            state.payment = {
                ...payload,
                attempts: state.payment.attempts+1
            }
        },
        setAddPaymentAttempts: (state) => {
            state.payment.attempts += 1;
        },
        setCheckInInfo: (state, { payload }) => {
            state.checkIn = {
                ...payload,
                attempts: state.checkIn.attempts+1
            }
        },
        setAddCheckInAttempts: (state) => {
            state.checkIn.attempts += 1;
        }
    }
});


// Action creators are generated for each case reducer function
export const { resetAgreement, setAgreement, setDebtInfo, setInitializeDebt, setSignature, setAgreementFile, setPaymentInfo, setAddPaymentAttempts, setCheckInInfo, setAddCheckInAttempts } = agreementSlice.actions;
